import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Seedlings extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_seedling.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Seedlings
        </h2>
        <p className="highlight">Timeline: 2 - 3 weeks</p>
        <h3>
        Planting Your Seed
        </h3>
        <p>
        Now that you have a germinated seed you’re ready to plant. You’ll want to start off in a small growing container, progressing up to bigger pots as the plant grows. Gently plant your seed ½” – 1” inch into the soil. Cover it with a light layer of soil, and lightly water it. During the sprouting phase, don’t let the soil dry out, but be careful you don’t overwater it and drown the sprouting seed. All you want to do is keep the soil moist. At this stage the plant should be getting light for 24 hours a day. It may take up to 10 days before it sprouts, so be patient. Seeds don't always sprout. If it's been 15 days and there’s no sign of the plant, you can safely assume that the seed will not sprout and try again.
        </p>
        <h3>
        Seedlings
        </h3>
        <p>
        Once your seedling emerges from the dirt you’ll want to increase the humidity. Seedlings don’t have established roots, so they get their water primarily from the air. You can create a tiny greenhouse by putting a plastic bag with holes cut in it loosely over the plant. Regularly spray the inside of the bag with water to keep it humid.
        </p>
        <h3>
        Transferring to a larger pot
        </h3>
        <p>
        Soon, your plant will out root the small container it's in You will need to transplant it into a much larger container. We recommend a 5 gallon for beginners, but you can also move up to a 7 or 10 gallon pot if you have the space. Be very careful during this process and do not let any of the roots be exposed to light during the transfer. Give it a nice watering and put it back under the light. Your plant will probably be shocked and not grow for a day or so, but don’t worry, this is normal after transplanting.
        </p>
        <GuideButton slugTo="vegetative-stage" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_seedlings.js